export default [
    {
        path: '/tendero-vip/calificaciones',
        meta: { nombre: 'Calificaciones' },
        name: 'tendero-vip.calificaciones',
        component: () => import(/* webpackChunkName: "productos" */ '../../pages/calificaciones').then(m => m.default || m)
    }
]
